/**
 * Returns an icon code from a name param
 * Allows to handle the case of roundabouts to return high resolution svg
 * Used in Routing feature and in Reference circuit feature
 * @param name
 * @returns {*|string}
 */
export function getIconCodeFromInstructionIconCode(name) {
  // Handle special case of roundabouts

  if (name.includes('ROUNDABOUT_EXIT_')) {
    // If name already contains 'ROUNDABOUT_EXIT_', just return the name as is
    return name
  }

  //If name just contains ROUNDABOUT_
  if (name.includes('ROUNDABOUT_')) {
    const parts = name.split('ROUNDABOUT_')
    const number = parseInt(parts[1], 10)

    // If the number is <= 12, replace 'ROUNDABOUT_' with 'ROUNDABOUT_EXIT_'
    // If the number is > 12, fallback to 'ROUNDABOUT'
    if (number <= 12) {
      return parts.join('ROUNDABOUT_EXIT_').split('EXIT_EXIT').join('EXIT')
    } else {
      return 'ROUNDABOUT'
    }
  }

  // Otherwise, just return the original name
  return name
}
